import React from 'react';
import Button from '../Button';
import Thumb from '../../svg/Thumb';
import MapWithPin from '../../svg/MapWithPin';
import Media from '../Media';
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';
import { withTranslation } from 'react-i18next';

class Course extends React.Component {

	render () {
		const { attraction, style, styleIndex, t, isMedieval } = this.props;

		return (
			<div className={`${style === 'full' ? 'w-full flex-col-reverse large:flex-row large:justify-between' : 'w-full medium:w-11/24 xxxlarge:w-5/12 flex-col-reverse'} flex mb-8 large:mb-40 justify-end ${styleIndex == 2 ? 'medium:pt-24' : ''} animate-on-hover`}>
				<div className={`flex relative ${style === 'full' ? 'w-88 large:w-112 mr-12 large:mr-20 flex-col' : 'flex-col xxxlarge:flex-row'}`}>
					<div className={`${style === 'full' ? '' : 'xxxlarge:w-76 xxxlarge:mr-6 xxxlarge:mb-16'}`}>
						<a data-aos="fade-up" title={attraction.title} href={attraction.url}><h3 className="max-w-sm text-smallm medium:text-largexl font-semi-bold mb-4 leading-tight">{attraction.title}</h3></a>
						{attraction.address ? <p className="inline-flex mb-4 max-w-xs text-xxxxsmall text-theme-dark-header"><span className="icon stroke mr-2"><MapWithPin /></span>{attraction.address}</p> : null}
						{isMedieval
							? <div data-aos="fade-up" data-aos-delay="100" className={`text-theme-dark-header mb-4 flex-shrink-0 text-xxxxsmall border-b border-theme-dark-border pb-5 flex flex-wrap`}>
								{attraction.status.map((item) => (
									<p className="inline-flex mr-2 mb-2 border border-border rounded px-4 h-8 items-center">{item}</p>
								))}
								{attraction.theme.map((item) => (
									<p className="inline-flex mr-2 mb-2 border border-border rounded px-4 h-8 items-center">{item}</p>
								))}
							</div>
							: <p data-aos="fade-up" data-aos-delay="100" className={`text-theme-dark-header mb-4 flex-shrink-0 flex text-xxxxsmall border-b border-theme-dark-border pb-5 ${style === 'full' ? '' : 'w-44'}`}><span className="mr-2 icon fill"><Thumb /></span> {attraction.recommendationCount} {t(parseInt(attraction.recommendationCount) === 1 ? 'recommendation' : 'recommendations')}</p>
						}
					</div>
					<div>
						<a href={attraction.url} className={`block ${style === 'full' ? '' : 'xxxlarge:flex xxxlarge:items-end xxxlarge:flex-1 xxxlarge:mt-6'}`}>
							<div data-aos="fade-up" data-aos-delay="200" className={`max-w-xs mb-6 text-xxsmall flex-1 ${style === 'full' ? '' : 'xxxlarge:mb-0'}`}>{parse(DOMPurify.sanitize(attraction.intro))}</div>
						</a>
						<div data-aos="fade-up" data-aos-delay="300" className={`self-start ${style === 'full' ? '' : 'xxxlarge:absolute left-0 bottom-0'}`}>
							<Button cta={t('Read more')} type="link" href={attraction.url} />
						</div>
					</div>
				</div>
				<a title={attraction.title} href={attraction.url}>
					<div data-aos="fade-up" data-aos-delay="400" className={`${style === 'full' ? 'large:mb-0' : ''} w-full mb-8 overflow-hidden`}>
						{!!attraction.mainMedia &&
							<Media media={attraction.mainMedia} />
						}
					</div>
				</a>
			</div>

		);
	}
}
export default withTranslation()(Course);
